import { FC } from 'react';

import { useAlertsState } from 'app/state/AlertsContext/hooks';
import { Alert } from 'app/state/AlertsContext/Provider';
import { PropsWithOnlyChildren } from 'app/types';

import Alerts from './Alerts';
import Notifications from './Notifications';

// Component Definition
const AlertProvider: FC<PropsWithOnlyChildren> = props => {
  const { alerts: allAlerts } = useAlertsState();

  const alertsWithIndex: Alert[] = allAlerts.map((alert, index) => ({
    ...alert,
    index,
  }));
  const alerts: Alert[] = alertsWithIndex.filter(alert => alert.alertType === 'alert');
  const notifications: Alert[] = alertsWithIndex.filter(alert => alert.alertType === 'notification');

  return (
    <>
      <Alerts alerts={alerts} />
      <Notifications alerts={notifications} />
      {props.children}
    </>
  );
};

export default AlertProvider;
